import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Chip, FormControl, ListItemText, OutlinedInput, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  StyledInputLabel,
  StyledMultipleMenuItem,
  StyledSelect
} from 'common/theme/fields/StyledSelect';

function MultipleSelectFieldAdapter({ input, id, label, options, ...rest }) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const size = useMemo(() => (isDesktop ? 'medium' : 'small'), [isDesktop]);

  const onChange = (event) => {
    input.onChange(event.target.value);
  };

  // Blindaje: durante la carga (initialValues async) input.value puede llegar undefined/no-array.
  const value = Array.isArray(input.value) ? input.value : [];

  return (
    <FormControl size={size} {...rest}>
      <StyledInputLabel id={id}>{label}</StyledInputLabel>
      <StyledSelect
        {...rest}
        labelId={id}
        id={id}
        input={<OutlinedInput label={label} />}
        value={value}
        onChange={onChange}
        renderValue={(selected) => {
          const labels = options.reduce((acc, curr) => {
            if (selected.indexOf(curr.value) >= 0) {
              acc.push(curr.label);
            }

            return acc;
          }, []);

          return labels.join(', ');
        }}
        multiple>
        {options.map((option) => (
          // `option.disabled` → opción solo-lectura (p. ej. planes adicionales: se ven marcados pero
          // se gestionan desde Pagos). `option.chip` → etiqueta dorada al lado (ej. "Adicional").
          <StyledMultipleMenuItem key={`checkbox-${option.value}`} value={option.value} disabled={Boolean(option.disabled)}>
            <Checkbox checked={value.indexOf(option.value) >= 0} />
            <ListItemText primary={option.label} />
            {option.chip && (
              <Chip label={option.chip} size="small" sx={{ ml: 1, bgcolor: 'gold.soft', color: 'gold.main', fontWeight: 700, height: 20 }} />
            )}
          </StyledMultipleMenuItem>
        ))}
      </StyledSelect>
    </FormControl>
  );
}

MultipleSelectFieldAdapter.propTypes = {
  input: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired
};

export default MultipleSelectFieldAdapter;
